import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import './suitComp.scss';
function SuitComp() {
	const dispatch = useDispatch();
	const show = useSelector((state) => state.suit.showDialog);
	// const chosenSuit = useSelector((state) => state.suit.chosenSuit);

	useEffect(() => {}, [show]);

	return show ? (
		<div>
			<div
				className="dialog"
				onClick={(e) => {
					const suite = e.target.getAttribute('data-value');
					console.log(suite);

					// socket.emit("choseDice", { value });
					// dispatch({ type: "SET_SUIT", value });
					dispatch({ type: 'SHOW_SUIT', value: false });

					dispatch({ type: 'CHOOSE_TRUMPET', suite: suite });
					// dispatch({ type: 'SHOW_CHOSEN_SUIT', value: true });
				}}
			>
				<div
					className="d-item d-color"
					style={{ backgroundPosition: '0% 0px' }}
					data-value="heart"
				>
					&nbsp;
				</div>
				<div
					className="d-item d-color"
					style={{ backgroundPosition: '33.33% 0px' }}
					data-value="bell"
				>
					&nbsp;
				</div>
				<div
					className="d-item d-color"
					style={{ backgroundPosition: '66.66% 0px' }}
					data-value="leave"
				>
					&nbsp;
				</div>
				<div
					className="d-item d-color"
					style={{ backgroundPosition: '99.99% 0px' }}
					data-value="nut"
				>
					&nbsp;
				</div>
			</div>
		</div>
	) : null;
}

export default SuitComp;
